import React, {Component} from 'react';
import {ConfigColumnsModal} from "./ConfigColumnsModal";
import {FaIcon} from "../FaIcon";
import {ColumnsSetsList} from "./ColumnsSetsList";
import { withTranslation } from 'react-i18next';

class ConfigColumnsWidgetClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.closeModal = this.closeModal.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    closeModal() {
        this.setState({
            modal: !this.state.modal
        });
    }

    handleClick(event) {
        event.preventDefault();
        this.setState({
            modal: true
        });
    }

    // rendering

    renderModal() {
        if (this.state.modal) {
            return <ConfigColumnsModal isOpen={this.state.modal}
                                       onClose={this.closeModal}
                                       handleColumnStateChange={this.props.handleColumnStateChange}
                                       activeColumns={this.props.activeColumns}
                                       activeColumnsSetId={this.props.activeColumnsSetId}
                                       onColumnsPositionChange={this.props.onColumnsPositionChange}
                                       onSaveColumnSet={this.props.onSaveColumnSet}
                                       onSelectColumnSet={this.props.onSelectColumnSet}
                                       columnsSets={this.props.columnsSets}
                                       flexIndicators={this.props.flexIndicators}
                                       canEditFlexIndicators={this.props.canEditFlexIndicators}
                                       ga4Indicators={this.props.ga4Indicators}
                                       ecommerceIndicators={this.props.ecommerceIndicators}
                                       paidMediaIndicators={this.props.paidMediaIndicators}
                                       metaIndicators={this.props.metaIndicators}
            />;
        } else {
            return null;
        }
    }

    renderSavedSets() {
        const { t } = this.props;
        // columnsSets es un objeto con estructura {id: {id, name, columns}}, necesitamos convertirlo a array de IDs
        // Filtrar el set "UNNAMED_UNSAVED_COLUMNS_SET" para no mostrarlo
        const columnsSetsKeys = Object.keys(this.props.columnsSets || {}).filter(setId => {
            const set = this.props.columnsSets[setId];
            return set && set.name !== 'UNNAMED_UNSAVED_COLUMNS_SET';
        });
        return [
            <p key={0} className="header-menu-title">{t('config_columns_widget.saved_columns')}</p>,
            <ColumnsSetsList key={1} 
                             columnsSets={columnsSetsKeys}
                             activeColumns={this.props.activeColumns}
                             activeColumnsSetId={this.props.activeColumnsSetId}
                             columnsSetsObject={this.props.columnsSets}
                             onSelectColumnSet={this.props.onSelectColumnSet}
                             onDeleteColumnSet={this.props.onDeleteColumnSet}
            />
        ]
    }

    render() {
        const { t } = this.props;
        return (
            <div className="filter-input">
                <div className="dashboard-header-option -wtih-menu">
                    <FaIcon iconName="columns"/>
                    <p className="header-option-label">{t('config_columns_widget.columns')}</p>
                    <div className="dashboard-header-menu">
                        <button className="header-menu-button" onClick={this.handleClick}>
                            <FaIcon iconName="cog"/>
                            {t('config_columns_widget.configure_columns')}
                        </button>
                        {this.renderSavedSets()}
                    </div>
                </div>
                {this.renderModal()}
            </div>
        );
    }
}

export const ConfigColumnsWidget = withTranslation()(ConfigColumnsWidgetClass);
export default ConfigColumnsWidget;